import React from "react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";

export interface StoreSubTypeFormData {
  languages: {
    languageCode: string;
    title: string;
  }[];
}

interface Props {
  register: UseFormRegister<StoreSubTypeFormData>;
  errors: FieldErrors<StoreSubTypeFormData>;
}

const StoreSubTypeForm: React.FC<Props> = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
    <div className="grid sm:grid-cols-2 gap-4">
      {/* English Brand Name */}
      <InputField
        placeholder=""
        label={t("title_en")}
        register={register("languages.0.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[0]?.title}
      />

      {/* Arabic Brand Name */}
      <InputField
        placeholder=""
        label={t("title_ar")}
        register={register("languages.1.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[1]?.title}
      />
    </div>
  );
};

export default StoreSubTypeForm;
